class Accordion extends HTMLElement {

    constructor() {
        super()
        this.init()
    }

    private init() {
        this.initClickEvent()
        this.activeFirstItem()
    }

    private initClickEvent() {
        const accordionList = this.querySelector('.accordion-js-list');

        if (!accordionList) {return}

        accordionList.addEventListener('click', (event) => {
            const target = (event.target instanceof Element)
                ? event.target.closest('.accordion-js-title') as HTMLButtonElement | null
                : null;
            if (target && target.classList.contains('accordion-js-title')) {
                const parent = target.closest('.accordion-js-item');
                const content = parent?.querySelector('.accordion-js-content') as HTMLElement | null;
                if (content) {
                    content.classList.contains('active') ? this.close(target, content) : this.open(target, content);
                }
            }
        });
    }

    private activeFirstItem() {
        if ( this.dataset.openFirstItem !== 'true') {return}

        const buttons = this.querySelectorAll('.accordion-js-title')
        const dropdowns = this.querySelectorAll('.accordion-js-content')

        const buttonActive = <HTMLButtonElement>buttons[0]
        const dropDownActive = <HTMLElement>dropdowns[0]

        this.open(buttonActive, dropDownActive)
    }
    
    private open (button: HTMLElement, dropDown: HTMLElement) {
        this.closeAllDrops(button, dropDown);
        dropDown.style.height = dropDown.scrollHeight + 'px';
        button.parentElement?.classList.add('active');
        button.classList.add('active');
        dropDown.classList.add('active');
    }

    private close (button: HTMLElement, dropDown: HTMLElement) {
        button.parentElement?.classList.remove('active');
        button.classList.remove('active');
        dropDown.classList.remove('active');
        dropDown.style.height = '';
    }

    private closeAllDrops (button: HTMLElement, dropDown: HTMLElement) {
        const accordionListItems = this.querySelectorAll('.accordion-js-item')
        accordionListItems.forEach((elem) => {
            const btn = <HTMLElement>elem.children[0]
            const drop = <HTMLElement>elem.children[1]
            if (btn !== button && drop !== dropDown) {
                this.close(btn, drop);
            }
        })
    }
}

export default Accordion